

export const createShapes = (map, layer, shapeObj) => {
  const style = {
    fillColor: 'transparent',
    strokeColor: '#0c529e',
    strokeWeight: 1,
    fillOpacity: 0.1,
  }
  layer.setStyle(style);
  if (shapeObj.type === "geoJSON") {
    layer.addGeoJson(shapeObj.data);
  }
  if (shapeObj.type === "shape") {
    let geoJSON = shapeToGeoJSON(shapeObj.data);
    layer.addGeoJson(geoJSON);
  }
  layer.addListener("dblclick", function (e) {
    let bounds = new window.google.maps.LatLngBounds();
    processPoints(e.feature.getGeometry(), bounds.extend, bounds);
    map.fitBounds(bounds);
  });
  layer.addListener("mouseover", function (e) {
    layer.overrideStyle(e.feature, { strokeWeight: 3 });
  });
  layer.addListener("mouseout", function (e) {
    if (!e.feature.getProperty('isClicked')) {
      layer.overrideStyle(e.feature, { strokeWeight: 1 });
    }
  });
  function processPoints(geometry, callback, thisArg) {
    if (geometry instanceof window.google.maps.LatLng) {
      callback.call(thisArg, geometry);
    } else if (geometry instanceof window.google.maps.Data.Point) {
      callback.call(thisArg, geometry.get());
    } else {
      geometry.getArray().forEach(function (g) {
        processPoints(g, callback, thisArg);
      })
    }
  }
}

const shapeToGeoJSON = (shape) => {
  const shapeArr = shape.split(" ");
  let coordArr = [];
  for (let i = 0; i < shapeArr.length; i = i + 2) {
    const long = parseFloat(shapeArr[i + 1]);
    const lat = parseFloat(shapeArr[i]);
    coordArr.push([long, lat]);
  }
  const coordinates = JSON.stringify(coordArr);
  const geoJSON = JSON.parse(`{"type":"FeatureCollection","features":[{"type":"Feature","id":"customShape","properties":{"stroke":"#555555","stroke-width":2,"stroke-opacity":1,"fill":"#0c529e","fill-opacity":0.1,"fips":48,"name":"customShape"},"geometry":{"type":"Polygon","coordinates":[${coordinates}]}}]}`)
  return geoJSON;
}